import React from 'react'
import { Link as IntlLink } from 'gatsby-plugin-intl';
import { URL_PREFIX } from '../misc/util';

export const Link = ({ to, children, ...html_props }) => {
  return (
    <IntlLink to={`${URL_PREFIX}${to}`} {...html_props}>
      {children}
    </IntlLink>
  )
};